<h2 mat-dialog-title>What would you like to do</h2>
<ng-container *ngIf="options()">
  <div class="search-box">
    <glxy-form-field>
      <input
        matInput
        #searchTerm
        [placeholder]="'Type a shortcut key'"
        (keyup)="checkShortcut(searchTerm.value, options())"
        autocomplete="off"
      />
    </glxy-form-field>
  </div>
  <mat-dialog-content>
    <mat-nav-list>
      <a
        mat-list-item
        tabindex="0"
        *ngFor="let option of options()"
        (click)="onOptionSelected(option)"
        (keyup.enter)="onOptionSelected(option)"
      >
        <h4 matListItemTitle class="row-title no-indent">
          {{ option.title }}
          <span class="key">{{ option.shortcut }}</span>
        </h4>
        <p matListItemLine>{{ option.description }}</p>
      </a>
    </mat-nav-list>
  </mat-dialog-content>
</ng-container>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
